import { getAddress, isAddress } from 'viem'

/**
 * Sodex API 用に EVM アドレスを正規化する
 * @param params.address ユーザー入力の EVM アドレス
 * @returns チェックサム付き EVM アドレス
 */
export const normalizeUserAddress = (params: { address: string }): string => {
  const { address } = params
  if (!isAddress(address)) {
    throw new Error(`Invalid EVM address: ${address}`)
  }
  return getAddress(address)
}
